var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18147 1.56474C6.27848 1.38076 4.36217 1.38076 2.45918 1.56474C1.43871 1.6635 0.656903 2.69905 0.610269 3.95955C0.463244 7.98521 0.463244 12.0149 0.610269 16.0405C0.656903 17.3024 1.43871 18.3366 2.45918 18.4354C4.36217 18.6194 6.27848 18.6194 8.18147 18.4354C9.20331 18.3366 9.98374 17.301 10.0304 16.0405C10.0564 15.3465 10.077 14.6415 10.0935 13.9297V6.07043C10.0771 5.36621 10.0561 4.66211 10.0304 3.95818C9.98374 2.70042 9.20331 1.66487 8.18147 1.56474Z",
    fill: "#B7C1C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8696 10.1233C11.8696 10.8036 11.9656 11.761 12.0644 12.5675C12.1645 13.3905 12.9875 13.9158 13.7446 13.5825C15.1327 12.9721 16.411 12.0683 17.3066 10.7515C17.4326 10.5665 17.4999 10.3479 17.4999 10.124C17.4999 9.90019 17.4326 9.68155 17.3066 9.49652C16.411 8.17979 15.1327 7.27454 13.7446 6.66555C12.9875 6.33225 12.1645 6.85757 12.0644 7.68053C11.9656 8.48703 11.871 9.4444 11.871 10.1233H11.8696Z",
    fill: "#B7C1C8",
    stroke: "#103046",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0318 3.95955C9.98237 2.69768 9.20194 1.6635 8.1801 1.56474C6.2771 1.38076 4.3608 1.38076 2.45781 1.56474C1.43871 1.6635 0.656903 2.69905 0.610269 3.95955C0.463244 7.98521 0.463244 12.0149 0.610269 16.0405C0.656903 17.3024 1.43871 18.3366 2.45918 18.4354C4.36217 18.6194 6.27848 18.6194 8.18147 18.4354C9.20331 18.3366 9.98374 17.301 10.0304 16.0405",
    fill: "#B7C1C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0318 3.95955C9.98237 2.69768 9.20194 1.6635 8.1801 1.56474C6.2771 1.38076 4.3608 1.38076 2.45781 1.56474C1.43871 1.6635 0.656903 2.69905 0.610269 3.95955C0.463244 7.98521 0.463244 12.0149 0.610269 16.0405C0.656903 17.3024 1.43871 18.3366 2.45918 18.4354C4.36217 18.6194 6.27848 18.6194 8.18147 18.4354C9.20331 18.3366 9.98374 17.301 10.0304 16.0405",
    stroke: "#103046",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8252 10.1235H11.8697H4.8252Z",
    fill: "#B7C1C8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8252 10.1235H11.8697",
    stroke: "#103046",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.c696143f1b25d2aeb87d70fc9bbecc3c.svg";
export { ForwardRef as ReactComponent };